<template>
  <div id="live-class" class="footer-hidden m-0 p-0">
    Live Class
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, vue/no-unused-components */

export default {
  components: {
  },
  data() {
    return {}
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    
  },
  mounted() {
    
  },
  destroyed() {
    
  }
}
</script>

<style lang="scss">

</style>
